module.exports = __webpack_public_path__ + "static/media/bkg_2.7aac8761.jpg";